import { applyMask as D } from "../common/apply-mask.mjs";
import { removeNonDigits as $ } from "../common/remove-non-digits.mjs";
const x = (s, e) => {
  const l = e.disableDialCodeAndPrefix ? !1 : e.forceDialCode, h = e.disableDialCodeAndPrefix ? !1 : e.insertDialCodeOnEmpty;
  let r = s;
  const a = (t) => e.trimNonDigitsEnd ? t.trim() : t;
  if (!r)
    return h && !r.length || l ? a(`${e.prefix}${e.dialCode}${e.charAfterDialCode}`) : a(r);
  if (r = $(r), r === e.dialCode && !e.disableDialCodeAndPrefix)
    return a(`${e.prefix}${e.dialCode}${e.charAfterDialCode}`);
  if (e.dialCode.startsWith(r) && !e.disableDialCodeAndPrefix)
    return a(l ? `${e.prefix}${e.dialCode}${e.charAfterDialCode}` : `${e.prefix}${r}`);
  if (!r.startsWith(e.dialCode) && !e.disableDialCodeAndPrefix) {
    if (l)
      return a(`${e.prefix}${e.dialCode}${e.charAfterDialCode}`);
    if (r.length < e.dialCode.length)
      return a(`${e.prefix}${r}`);
  }
  const o = () => {
    let t = e.dialCode.length;
    e.disableDialCodeAndPrefix && (t = 0);
    const C = r.slice(0, t), p = r.slice(t);
    return {
      phoneLeftSide: C,
      phoneRightSide: p
    };
  };
  let { phoneLeftSide: d, phoneRightSide: i } = o();
  return d = `${e.prefix}${d}${e.charAfterDialCode}`, i = D({
    value: i,
    mask: e.mask,
    maskSymbol: e.maskChar,
    allowMoreDigitsThanMaskAllows: e.allowMoreDigitsThanMaskAllows,
    trimNonMaskCharsLeftover: e.trimNonDigitsEnd
  }), e.disableDialCodeAndPrefix && (d = ""), a(`${d}${i}`);
};
export {
  x as formatPhone
};
